import { useCallback, useState, useContext, useEffect } from "react";
import { getOrganizationBadges, addOrganizationBadges, deleteOrganizationBadges } from "../MyProfile/Service/profileService";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import {
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import LoginLoader from "../../../Shared/Sidebar/LoginLoader";
import { debounce } from "lodash";
import { InputText } from "primereact/inputtext";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";

let employeeId;
const OrgBadgeSetting = () => {
  const [columns, setColumns] = useState(["Badge Name", "Badge Icon"]);
  const [rows, setRows] = useState([{}]); // Rows state
  const [editIndex, setEditIndex] = useState(null);
  const [orgBadgesList, setOrgBadgesList] = useState([])
  const defaultImage = "/images/placeholder_profile.png";
  const [file, setFile] = useState(null);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [orgBadgesId, setOrgBadgesId] = useState(0);
  const [Isloading, setIsloading] = useState(false);
  const [IsImageloading, setIsImageloading] = useState(false);
  let toster = useContext(TostMsg);
  const [errors, setErrors] = useState({});
 const [data, setData] = useState({
    BadgeName: "",
    BadgeIconPath: "",
  });
  let SearchValue = "";

  useEffect(() => {
    GetOrgBadges();
  }, []);

  const validateOrgBadges = (data, index) => {
    const newErrors = {};
    newErrors[`${index}-BadgeName`] =
      !data.BadgeName || data.BadgeName.trim() === ""
        ? "BadgeName is required"
        : undefined;
    newErrors[`${index}-BadgeIconPath`] =
      !data.BadgeIconPath || data.BadgeIconPath.trim() === ""
        ? "BadgeIconPath is required"
        : undefined;
    setErrors((prev) => ({ ...prev, ...newErrors }));
    const isValid = Object.values(newErrors).every(
      (error) => error === undefined
    );
    return isValid;
  };

  async function GetOrgBadges() {
    setIsloading(true);
    try {
      let responce = await getOrganizationBadges({});
      setOrgBadgesList(responce?.Data);
    } catch (err) {
      // toster.current.error(ERROR_LIST.AwardMasterData);
    } finally {
      setIsloading(false);
    }
  }

  const handleAddRow = () => {
    setOrgBadgesList([
      ...orgBadgesList,
      { BadgeName: "", BadgeIconPath: "" },
    ]);
    setEditIndex(orgBadgesList.length); 
  };

  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };

  const handleRemoveSpecificRow = (rowIdx) => () => {
    const updatedRows = rows.filter((_, idx) => idx !== rowIdx);
    setRows(updatedRows);
  };

 
  const handleChange = (rowIdx, colName) => (e) => {
    const { value } = e.target;
    setOrgBadgesList(prevList => {
      const newList = prevList.map((item, idx) =>
        idx === rowIdx ? { ...item, [colName]: value } : item
      );
      return newList;
    });
    setData(prev => ({ ...prev, [colName]: value }));
    validateOrgBadges({ ...orgBadgesList[rowIdx], [colName]: value }, rowIdx);
  };

  const handleFileChange = useCallback(async (event, index) => {
    const selectedFile = event.target.files;
    setFile({ files: selectedFile, index });
  }, []);

  const cancelOrgWfh = () => {
    GetOrgBadges();
    setOrgBadgesList(prevList => {
      setEditIndex(null);
      const len = prevList.length;
      if (len === 0) return prevList;
      const lastItem = prevList[len - 1];
      const isEmpty = lastItem &&
        !lastItem.BadgeName &&
        !lastItem.BadgeIconPath;
      if (isEmpty) {
        return prevList.slice(0, -1);
      }
      return prevList;
    });
  }


  async function addOrgBadges(index, data) {
    const body = {
      Id: data?.Id || 0,
      OrgId: userDetails?.OrgId,
      BadgeName: data.BadgeName,
      BadgeIconPath: data.BadgeIconPath,
    };
    try {
      await addOrganizationBadges(body);
      if (orgBadgesId) {
        // toster.current.sucess('Org Leave Updated');
      } else {
        // toster.current.sucess('Org Leave Added');
      }
      
      setOrgBadgesList([]);
      setEditIndex(null);
      GetOrgBadges();
      setIsloading(false);
    } catch (err) {
      setIsloading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handleEditClick = (index , data) => {
    setOrgBadgesId(data?.Id);
    setEditIndex(index);
  };

  const handleWfhlstDelete = (Id) => {
    setOrgBadgesId(Id);
  };

  async function DeleteOrgBadges() {
    setIsloading(true);
    if (orgBadgesId) {
      let body = {
        Id: orgBadgesId,
      };
      try {
        let orgBadgesDeleteList = await deleteOrganizationBadges(body);
        if (orgBadgesDeleteList) {
          setIsloading(false);
          GetOrgBadges();
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  useEffect(() => {
    if (file?.files) {
      uploadPolicyDocFile(file.files, file.index);
    }
  }, [file]);

  async function uploadPolicyDocFile(files, index) {
    setIsImageloading(true);
    if (files) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
      }
        let params = {
        UploadType: UploadFile_KEYS.OrgBadgesSetting,
        RefId: 0,
      }
      try {
        const response = await uploadDoc(params,formData);
        const data = await response;
        const ImageURL = data?.Data;
        if (ImageURL?.[0]) {
          handleChange(
            index,
            "BadgeIconPath"
          )({
            target: { value: ImageURL[0] },
          });
        }
        setIsImageloading(false);
      } catch (error) {
        setIsImageloading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      }
    } else {
      setIsImageloading(false);
      toster.current.warn("No file selected");
    }
  }

  const handleInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      SearchValue = value;
      let filteredList = orgBadgesList.filter((orgBadges) =>
        orgBadges.BadgeName?.toLowerCase().includes(SearchValue?.toLowerCase())
      );
      if (SearchValue != "") {
        setOrgBadgesList(filteredList);
      } else {
        GetOrgBadges();
      }
    }, 800),
    [orgBadgesList]
  );

  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4">
        </div>
        <div className="title-text">
          <h3>Badges Types({orgBadgesList?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
            {!editIndex && (
              <button
                className="addaward-btn"
                data-toggle="tooltip"
                data-placement="top"
                title=""
                data-bs-original-title=""
                fdprocessedid="izng1j"
                onClick={handleAddRow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                </svg>
                Badges
              </button>
            )}
          </div>
        </div>


        <div className="col-md-12 column">
          <table className="table table-bordered table-hover" id="tab_logic">
            <thead>
              <tr>
                {columns.map((colName, colIdx) => (
                  <th key={colIdx} className="text-left">
                    {colName}
                  </th>
                ))}
                <th className="text-left" style={{ width: "100px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {orgBadgesList?.map((data, index) => (
                <tr key={index}>
                  {editIndex === index ? (
                    <>
                      <td>
                        <input
                          type="text"
                          value={data.BadgeName}
                          onChange={handleChange(index, "BadgeName")}
                          placeholder="Badge Name"
                          className={`form-control ${errors[`${index}-BadgeName`] ? "is-invalid" : ""
                            }`}
                        />
                        {errors[`${index}-BadgeName`] && (
                          <div className="invalid-feedback">
                            {errors[`${index}-BadgeName`]}
                          </div>
                        )}
                      </td>

                      <td>
                        {" "}
                        <div className="loadresumes">
                          <div className="inner">
                            {data.BadgeIconPath ? (
                              <img
                                src={data.BadgeIconPath}
                                className="editaddimg"
                              />
                            ) : (
                              <>
                                {IsImageloading ? (
                                  <LoginLoader />
                                ) : (
                                  <img
                                    src="/images/org-img/learn/add.png"
                                    className="editaddimg"
                                  />
                                )}
                              </>
                            )}
                          </div>

                          <label
                            htmlFor={`file-upload-${index}`}
                            className="custom-file-upload"
                          >
                            <i
                              className="fa fa-upload me-2"
                              aria-hidden="true"
                            ></i>
                            Upload Badges Image
                          </label>

                          <input
                            type="file"
                            id={`file-upload-${index}`}
                            style={{
                              display: "none",
                            }}
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, index)}
                          />
                          {errors[`${index}-BadgeIconPath`] && (
                            <div className="text-danger mt-1">
                              {errors[`${index}-BadgeIconPath`]}
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <>
                          <img
                            onClick={() => {
                              cancelOrgWfh();
                            }}
                            src="/images/org-img/profile/close.png"
                            title="Cancel"
                            className="editactions me-2"
                            style={{ width: "17px" }}
                          />
                          <img
                            onClick={() => {
                              if (validateOrgBadges(data, index)) {
                                addOrgBadges(index, data);
                              }
                            }}
                            src="/images/org-img/profile/check.png"
                            title="Confirm"
                            className="editactions"
                            style={{ width: "17px" }}
                          />
                        </>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{data?.BadgeName}</td>
                      <td className="">
                        {data?.BadgeIconPath ? (
                          <img
                            src={data?.BadgeIconPath || defaultImage}
                            onError={handleImageError}
                            style={{
                              width: "auto",
                              height: "30px",
                            }}
                          />
                        ) : (
                          <img src={data?.BadgeIconPath} className="w-4" />
                        )}
                      </td>
                      <td className="">
                        <button
                          disabled={editIndex != null}
                          className="editactions me-2"
                          onClick={() => handleEditClick(index , data)}
                        >
                          <img
                            src="/images/tickets/edit-ico.svg"
                            className=""
                            title="Edit"
                          />
                        </button>
                        <button
                          className="editactions"
                          title="Delete"
                          data-bs-toggle="modal"
                          data-bs-target="#delete-org-badges"
                          onClick={() => {
                            handleWfhlstDelete(data?.Id);
                            // GetMasterSystemAlertList("Delete_Award", 1);
                          }}
                        >
                          <img
                            src="/images/tickets/delete.svg"
                            className=""
                            title="Delete"
                          />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal fade " id="delete-org-badges">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <strong className="modal-title">Are you sure?</strong>
                {/* <p>{deleteContent}</p> */}
                <p>Do you really want to delete this Badge?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  data-bs-dismiss="modal"
                  onClick={() => DeleteOrgBadges()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrgBadgeSetting;
